import axios from "axios";
import { apiURL } from "../config/default";

import { alert } from "./alert";
import setAuthHeader from "../utils/setAuthHeader";
import { isArray } from "jquery";


export const usersRetreive = (pageNo, search, accountType, sortBy) => async (dispatch) => {
  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }

  try {
    const res = await axios.get(
      `${apiURL}admin/get-all-users?page=${pageNo ? pageNo : ""}&search=${search ? search : ""
      }&accountType=${accountType ? accountType : ""}&sortBy=${sortBy ? sortBy : ""}`
    );
    return res?.data;
  } catch (err) {
    const errors = err.response.data.error;

    if (errors) {
      errors.forEach((error) => {
        dispatch(alert(error.msg, "danger", { marginTop: "2em" }));
      });
    }
  }
};
export const deleteUser = (id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }

  try {
    const res = await axios.delete(`${apiURL}admin/delete-user/${id}`);
    return res?.data;
  } catch (err) {
    const errors = err.response.data.error;

    if (errors) {
      errors.forEach((error) => {
        dispatch(alert(error.msg, "danger", { marginTop: "2em" }));
      });
    }
  }
};
export const getReferalUsers = () => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }

  try {
    const res = await axios.get(
      `${apiURL}admin/get-users-refralcount`,
      _config
    );
    return res;
  } catch (err) {
    const errors = err.response.data.error;

    if (errors) {
      errors.forEach((error) => {
        dispatch(alert(error.msg, "danger", { marginTop: "2em" }));
      });
    }
  }
};
export const paidUsersRetreive = () => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }

  try {
    const res = await axios.get(`${apiURL}admin/get-all-paid-users`, _config);
    return res;
  } catch (err) {
    const errors = err.response.data.error;

    if (errors) {
      errors.forEach((error) => {
        dispatch(alert(error.msg, "danger", { marginTop: "2em" }));
      });
    }
  }
};
export const getUsersDetails = (id) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }

  try {
    const res = await axios.get(
      `${apiURL}admin/get-user-details/${id}`,
      _config
    );
    return res;
  } catch (err) {
    const errors = err.response.data.error;

    if (errors) {
      errors.forEach((error) => {
        dispatch(alert(error.msg, "danger", { marginTop: "2em" }));
      });
    }
  }
};
export const getVendorDetails = (id) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }

  try {
    const res = await axios.get(
      `${apiURL}admin/get-vendor-details/${id}`,
      _config
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.error;

    if (errors) {
      errors.forEach((error) => {
        dispatch(alert(error.msg, "danger", { marginTop: "2em" }));
      });
    }
  }
};

export const createVendor = (formData) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }
  try {
    const res = await axios.post(
      `${apiURL}admin/create-vendor`,
      JSON.stringify(formData),
      _config
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.error;
    if (isArray(errors)) {
      if (errors) {
        errors.forEach((error) => {
          dispatch(
            alert(error.msg, "danger", {
              marginTop: "3em",
              marginBottom: "2em",
            })
          );
        });
      }
    } else {
      dispatch(
        alert(errors, "danger", { marginTop: "3em", marginBottom: "2em" })
      );
    }
  }
};

export const updateVendor = (formData, id) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }
  try {
    const res = await axios.post(
      `${apiURL}admin/update-vendor/${id}`,
      JSON.stringify(formData),
      _config
    );
    return res.data;
  } catch (err) {
    console.log(err);
    // const errors = err.response.data.error;
    // if (isArray(errors)) {
    //   if (errors) {
    //     errors.forEach((error) => {
    //       dispatch(
    //         alert(error.msg, 'danger', {
    //           marginTop: '3em',
    //           marginBottom: '2em',
    //         })
    //       );
    //     });
    //   }
    // } else {
    //   dispatch(
    //     alert(errors, 'danger', { marginTop: '3em', marginBottom: '2em' })
    //   );
    // }
  }
};

export const getReferralUsersDetails = (id) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }

  try {
    const res = await axios.get(
      `${apiURL}admin/get-referal-info/${id}`,
      _config
    );
    return res;
  } catch (err) {
    const errors = err.response.data.error;

    if (errors) {
      errors.forEach((error) => {
        dispatch(alert(error.msg, "danger", { marginTop: "2em" }));
      });
    }
  }
};
export const bulkUsers = (formData) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }
  try {
    const res = await axios.post(
      `${apiURL}admin/bulk-insertion`,
      JSON.stringify(formData),
      _config
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.error;
    if (isArray(errors)) {
      if (errors) {
        errors.forEach((error) => {
          dispatch(
            alert(error.msg, "danger", {
              marginTop: "3em",
              marginBottom: "2em",
            })
          );
        });
      }
    } else {
      dispatch(
        alert(errors, "danger", { marginTop: "3em", marginBottom: "2em" })
      );
    }
  }
};

export const updateBrandFilters = (id, filterData) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }
  try {
    const res = await axios.post(
      `${apiURL}admin/update-brand-filters/${id}`,
      JSON.stringify(filterData),
      _config
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.error;
    if (isArray(errors)) {
      if (errors) {
        errors.forEach((error) => {
          dispatch(
            alert(error.msg, "danger", {
              marginTop: "3em",
              marginBottom: "2em",
            })
          );
        });
      }
    } else {
      dispatch(
        alert(errors, "danger", { marginTop: "3em", marginBottom: "2em" })
      );
    }
  }
};


// update-user-details
export const updateUserDetails = (id, data) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }
  try {
    const res = await axios.post(
      `${apiURL}admin/update-user-details/${id}`,
      JSON.stringify(data),
      _config
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.error;
    if (Array.isArray(errors)) {
      if (errors) {
        errors.forEach((error) => {
          dispatch(
            alert(error.msg, "danger", {
              marginTop: "3em",
              marginBottom: "2em",
            })
          );
        });
      }
    } else {
      dispatch(
        alert(errors, "danger", { marginTop: "3em", marginBottom: "2em" })
      );
    }
  }
};

// update-user-details
export const upgradeUserDetails = (id, data) => async (dispatch) => {
  const _config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }
  try {
    const res = await axios.put(
      `${apiURL}admin/upgrades/${id}`,
      JSON.stringify(data),
      _config
    );
    return res.data;
  } catch (err) {
    const errors = err.response.data.error;
    if (Array.isArray(errors)) {
      if (errors) {
        errors.forEach((error) => {
          dispatch(
            alert(error.msg, "danger", {
              marginTop: "3em",
              marginBottom: "2em",
            })
          );
        });
      }
    } else {
      dispatch(
        alert(errors, "danger", { marginTop: "3em", marginBottom: "2em" })
      );
    }
  }
};
// get-site-traffic
export const getSiteTraffic = (pageNo, search, limit = 20, sortBy = "", sortDir = "") => async (dispatch) => {
  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }

  try {
    const res = await axios.get(
      `${apiURL}admin/analytics-page-visits/ips?search=${search ? search : ""}&page=${pageNo ? pageNo : "1"}&limit=${limit}&sortBy=${sortBy}&sortDir=${sortDir}`
    );
    return res?.data;
  } catch (err) {
    const errors = err?.response?.data?.error;

    if (errors && Array.isArray(errors)) {
      errors.forEach((error) => {
        dispatch(alert(error.msg, "danger", { marginTop: "2em" }));
      });
    } else if (errors) {
      dispatch(alert(errors, "danger", { marginTop: "2em" }));
    }
  }
};

// get-ip-history
export const getIPHistory = (ip, pageNo = 1, limit = 50, sort = "desc", startDate, endDate) => async (dispatch) => {
  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }

  try {
    let query = `${apiURL}admin/analytics-page-visits/ip/${ip}?page=${pageNo}&limit=${limit}&sort=${sort}`;
    if (startDate) query += `&startDate=${startDate}`;
    if (endDate) query += `&endDate=${endDate}`;

    const res = await axios.get(query);
    return res?.data;
  } catch (err) {
    const errors = err?.response?.data?.error;

    if (errors && Array.isArray(errors)) {
      errors.forEach((error) => {
        dispatch(alert(error.msg, "danger", { marginTop: "2em" }));
      });
    } else if (errors) {
      dispatch(alert(errors, "danger", { marginTop: "2em" }));
    }
  }
};
// update-ip-alert-status
export const updateIPAlertStatus = (ip, ignored) => async (dispatch) => {
  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }

  try {
    const res = await axios.patch(`${apiURL}admin/analytics-alerts/ip/${ip}`, {
      ignored
    });
    return res?.data;
  } catch (err) {
    const errors = err?.response?.data?.error;

    if (errors && Array.isArray(errors)) {
      errors.forEach((error) => {
        dispatch(alert(error.msg, "danger", { marginTop: "2em" }));
      });
    } else if (errors) {
      dispatch(alert(errors, "danger", { marginTop: "2em" }));
    }
  }
};

// update-ip-flag-status
export const updateIPFlagStatus = (ip, payload) => async (dispatch) => {
  const token = localStorage.getItem("token");
  if (token) {
    setAuthHeader(token);
  }

  try {
    const res = await axios.patch(`${apiURL}admin/analytics-page-visits/ip/${ip}/flag`, payload);
    return res?.data;
  } catch (err) {
    const errors = err?.response?.data?.error;

    if (errors && Array.isArray(errors)) {
      errors.forEach((error) => {
        dispatch(alert(error.msg, "danger", { marginTop: "2em" }));
      });
    } else if (errors) {
      dispatch(alert(errors, "danger", { marginTop: "2em" }));
    }
  }
};
